import React, { useEffect } from "react";

import { LoginContainer } from "../../../../styles/Login/Login";
import { logout } from "../../../../utils/utilityFunctions";
import NonAuthLayout from "../../components/header/NonAuthHeaderLayout";
import LoginForm from "../../layout/signin/LoginForm";

const Login = () => {
    useEffect(() => {
        logout();
    }, []);

    return (
        <React.Fragment>
            <NonAuthLayout />
            <div className="flex login-container--wrap">
                <LoginContainer>
                    <div className="kuda-auth--layout">
                        <div className="auth-container">
                            <div className="animated kudaFadeInUp">
                                <h1 className="page-heading-title">Sign In To Your Account</h1>
                            </div>

                            <div className="flex align-start justify-between">
                                <LoginForm />
                            </div>
                        </div>
                    </div>
                </LoginContainer>
            </div>
        </React.Fragment>
    );
};

export default Login;
